module.exports = __webpack_public_path__ + "assets/img/warrior-name-629bc3b3.png";